import React from 'react';

import { Text } from '@lightspeed/flame/Text';
import concat from 'lodash/concat';
import { Route, RouteProps } from 'react-router-dom';

import NoRights from 'pages/views/generic/NoRights';
import Modules from 'shared_modules/Modules';

interface ComponentProps extends RouteProps {
  blockedAccountStatuses?: string | string[];
  modules?: ModuleName | ModuleName[];
  rights?: string | string[];
}

type Props = ComponentProps & {
  component: React.ComponentClass<ComponentProps> | React.FC<ComponentProps>;
};

const RouteIfRights: React.FC<Props> = ({
  blockedAccountStatuses = [],
  component: Component,
  modules = [],
  rights = [],
  ...rest
}) => {
  const appRights = concat([], rights);
  const hasRights = appRights.every(right => window.merchantos.session.hasRight(right));

  const appModules = concat([], modules);
  const hasModules = appModules.every(module => Modules.hasModule(module));

  const appBlockedAccountStatuses = concat([], blockedAccountStatuses);
  const currentAccountStatus = window.merchantos.session.getAccountStatus();
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  const isAccountStatusNotAllowed = appBlockedAccountStatuses?.includes(currentAccountStatus);

  // Return `<Route>` but with `<NoRights>` component if rights are not sufficient.
  // If they are, `component` for given `<Route>` will be rendered normally with
  // `props` passed down to it. Using react-router's render props pattern:
  // https://reacttraining.com/react-router/web/api/Route/render-func
  // And based on ideas from this article:
  // https://tylermcginnis.com/react-router-protected-routes-authentication/
  return (
    <Route
      {...rest}
      render={props => {
        // Modules and rights restrictions are only applied when required
        // to allow just modules, just rights, or both
        if (!hasModules) {
          return <NoRights rights={appModules.join(', ')} />;
        }
        // Backwards compatible
        if (!hasRights) {
          return <NoRights rights={appRights.join(', ')} />;
        }
        // Check if the account status has been blocked
        if (isAccountStatusNotAllowed) {
          return (
            <NoRights
              customText={
                <Text>
                  Access restricted. Account status of <var>&apos;{currentAccountStatus}&apos;</var>{' '}
                  is not allowed to access this section.
                </Text>
              }
            />
          );
        }
        // @ts-ignore
        return <Component {...props} />;
      }}
    />
  );
};

export default RouteIfRights;
